import { render, staticRenderFns } from "./Chatbots.vue?vue&type=template&id=354b85c9&scoped=true&"
import script from "./Chatbots.vue?vue&type=script&lang=js&"
export * from "./Chatbots.vue?vue&type=script&lang=js&"
import style0 from "./Chatbots.vue?vue&type=style&index=0&id=354b85c9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b85c9",
  null
  
)

export default component.exports